import {Col, Row} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {Card} from "@mui/material";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Footer from "../Footer";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import {useMaterialUIController} from "../../context";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from "react-hook-form";
import {getCommunicationTemplate, saveCommunicationTemplate, uploadTemplateFile,} from "../common/api/WebApi";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";

import {CKEditor} from '@ckeditor/ckeditor5-react';
import {ButtonView, ClassicEditor} from 'ckeditor5';
import Divider from "@mui/material/Divider";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import {CONFIG} from "../common/EditorConfig";
import Preview from "../common/modal/preview";


export default function CommunicationTemplates(props) {

  let {guid} = useParams();

  const [isNew, setIsNew] = useState(true);

  const [controller] = useMaterialUIController();
  const {darkMode} = controller;

  const navigate = useNavigate();

  const [context, setContext] = useContext(AppContext);
  const [saving, setSaving] = useState(false);
  const [templateReady, setTemplateReady] = useState(false);
  const [template, setTemplate] = useState();
  const [templateBody, setTemplateBody] = useState();
  const [templates, setTemplates] = useState([]);
  const [templateIndex, setTemplateIndex] = useState(0);

  const [editorState, setEditorState] = useState();

  useEffect(() => {
    reset();
  }, []);

  const {register, handleSubmit, setValue, reset} = useForm({
    values: handleDefaultValues(template)
  });

  useEffect(() => {
    if (guid && 'new' !== guid) {
      setIsNew(false);
      setTemplateReady(false);
      getCommunicationTemplate(guid).then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setTemplate(result);
          setTemplateBody(result.templateBody);
          setTemplateReady(true);
        }
      });
    } else {
      reset();
      setTemplate({
        templateName: null,
        id: null,
        guid: null,
        templateSubject: null,
        templateBody: '',
      });
      setIsNew(true);
      setTemplateReady(true);
    }
  }, [guid])

  const sidenavItems = [
    {icon: "person", label: "First Name", replacement: "{firstName}"},
    {icon: "person", label: "Last Name", replacement: "{lastName}"},
    // {icon: "person_outline", label: "Child Name", replacement: "{childName}"},

    {icon: "apps", label: "Account", replacement: "{membership}"},

    {icon: "", type: "divider"},

    {icon: "sell", label: "Formatted Receipt", replacement: "{formattedReceipt}"},
    {icon: "payment", label: "Formatted Refund", replacement: "{formattedRefund}"},
    {icon: "receipt", label: "Formatted Invoice", replacement: "{formattedInvoice}"},
    {icon: "event", label: "Event Name", replacement: "{eventName}"},
    {icon: "event", label: "Event Date", replacement: "{eventDate}"},
    {icon: "event_busy", label: "Event Cancellation", replacement: "{eventCancellation}"},
    {icon: "subject", label: "Wait List Notification", replacement: "{eventWaitlistConfirmationLink}"},
    {icon: "grading", label: "Guest Waiver", replacement: "{guestWaiver}"},

    {icon: "", type: "divider"},
    {icon: "emergency", label: "Create Password", replacement: "{createPasswordLink}"},
    {icon: "emergency", label: "Forgot Password", replacement: "{forgotPasswordLink}"},

    {icon: "", type: "divider"},
    {icon: "card_giftcard", label: "Gift Card Link", replacement: "{giftCardLink}"},
    {icon: "favorite", label: "Gift Card Recipient", replacement: "{giftCardRecipient}"},
    {icon: "mood", label: "Gift Card From", replacement: "{giftCardFrom}"},
    {icon: "note", label: "Gift Card Message", replacement: "{giftCardMessage}"},
    {icon: "paid", label: "Gift Card Balance", replacement: "{giftCardBalance}"},

    {icon: "", type: "divider"},
    {icon: "card_giftcard", label: "Gift Link", replacement: "{giftLink}"},
    {icon: "favorite", label: "Gift Recipient", replacement: "{giftRecipient}"},
    {icon: "mood", label: "Gift From", replacement: "{giftFrom}"},
    {icon: "note", label: "Gift Message", replacement: "{giftMessage}"},
    {icon: "store", label: "Gift Item", replacement: "{giftItem}"},

  ];

  const handleChange = (e, editor) => {
    setTemplateBody(editor.getData());
  }

  const editorRef = useRef(null);

  const handleSaveTemplate = async (data) => {
    setSaving(true);
    let d = {...data};

    const editorData = editorRef.current.getData();

    const cleaned = editorData
      .replace(/^<p>/i, '<div>')
      .replace(/<\/p>$/i, '</div>');

    d.templateBody = cleaned;

    let promise = saveCommunicationTemplate(d);

    let _context = {...context};
    const toastMessage = 'Template successfully saved.';
    _context.toast = {
      message: toastMessage,
      type: 'success'
    }
    setContext({..._context});

    promise.then(result => {
      setSaving(false);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setTemplate(result);
        setTemplateBody(result.templateBody);
        if (isNew) {
          navigate(`/communication/templates/${result.guid}`);
        }
      }
    });
  }

  const renderSidenavItems = sidenavItems.map(({icon, label, href, replacement, type}, key) => {
    const itemKey = `item-${key}`;

    return (

      type === "divider" ? <Divider key={itemKey} sx={{my: 1}}/> :
        <MDBox key={itemKey} component="li" pt={0}>
          <MDTypography
            component="a"
            href={`#${href}`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              insertText(replacement);
            }}
            variant="button"
            fontWeight="regular"
            textTransform="capitalize"
            sx={({
                   borders: {borderRadius},
                   functions: {pxToRem},
                   palette: {light},
                   transitions,
                 }) => ({
              display: "flex",
              alignItems: "center",
              borderRadius: borderRadius.md,
              padding: `${pxToRem(10)} ${pxToRem(16)}`,
              transition: transitions.create("background-color", {
                easing: transitions.easing.easeInOut,
                duration: transitions.duration.shorter,
              }),

              "&:hover": {
                backgroundColor: light.main,
              },
            })}
          >
            <MDBox mr={1.5} lineHeight={1} color={darkMode ? "white" : "dark"}>
              <Icon fontSize="small">{icon}</Icon>
            </MDBox>
            {label}
          </MDTypography>
        </MDBox>
    );
  });


  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {

          const body = new FormData();
          loader.file.then((file) => {
            const fileType = file.type;
            const fileName = file.name;
            const reader = new FileReader();

            reader.onload = function (evt) {
              let fileRequest = {
                fileType: fileType,
                fileName: fileName,
                data: btoa(evt.target.result)
              }

              uploadTemplateFile(fileRequest).then(result => {
                if (result.error) {
                  setContext({...context, error: {message: result.message}});
                } else {
                  loader.uploaded = true;
                  loader.uploadUrl = result;
                }
                resolve({
                  default: result.fileLocation
                })
              });
            }
            reader.readAsBinaryString(file);
          });
        })
      }
    }
  }

  const [blurEditor, setBlurEditor] = useState();

  const insertText = (text) => {
    if (!blurEditor) {
      return;
    }

    blurEditor.model.change(writer => {
      writer.insertText(text + " ", blurEditor.model.document.selection.getFirstPosition());
      writer.setSelection(writer.createPositionAt(blurEditor.model.document.getRoot(), 'end'));
    });
  };

  const handleReady = (editor) => {
    editorRef.current = editor;
    setBlurEditor(editor);
  };

  const handleBlur = (event, editor) => {
    setBlurEditor(editor);
  };

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  const [preview, setPreview] = useState();
  const [showPreview, setShowPreview] = useState(false);

  const doPreview = () => {
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
                                              <html>
                                              <head>
                                                  <title>Print</title>
                                                  <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; font-size:0.9rem; line-height:0.9rem; }
                                                      p{margin:0; padding:0; line-height:13px; font-size:12px;}
                                                      h1,h2,h3,h4,h5,h6{font-size:14px; margin:0; padding:0; line-height:15px}
                                                      .no-print { display: none !important; }
                                                  </style>
                                              </head>
                                              <body onload="window.print(); window.close();">
                                                   ${preview}
                                              </body>
                                              </html>
                                            `);
    printWindow.document.close();
  }

  function previewPlugin(editor) {
    editor.ui.componentFactory.add('preview', (locale) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'Preview',
        tooltip: true,
        withText: true
      });

      view.on('execute', () => {
        const data = editor.getData();
        setPreview(data);
        const previewWindow = window.open('', '_blank');
        previewWindow.document.write(data);
        previewWindow.document.close();
      });

      return view;
    });
  }

  const handleTemplateSelection = (template) => {
    setValue('templateSubject', template.subject);
    setValue('templateName', template.name);
    setTemplateBody(template.html);

    console.log("SELECTED TEMPLATE:", template);

    alert(
      `Loaded "${template.name}" template.\n\nHTML inserted into editor state.`
    );
  };

  return (
    <DashboardLayout>
      <Meta pageTitle={'Communication Templates'}/>
      <ContextSearchNavbar title="Communication Templates"/>

      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <MDBox
              sx={{
                position: "sticky",
                top: "95px",
              }}>
              <Card
                sx={{
                  borderRadius: ({borders: {borderRadius}}) => borderRadius.lg,
                }}
              >
                <MDTypography variant="h5" fontWeight="regular" p={2} pb={0}>
                  Replacement Variables
                </MDTypography>
                <MDTypography variant="p" fontWeight="light" p={2} pb={0}>
                  <span className={'fa fa-info-circle'}></span> Click items below to insert into template.
                </MDTypography>
                <Divider/>
                <MDBox
                  component="ul"
                  display="flex"
                  flexDirection="column"
                  p={2}
                  pt={0}
                  m={0}
                  sx={{listStyle: "none"}}
                >
                  {renderSidenavItems}
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={9}>
            <MDBox mb={3}  style={{
              position: 'sticky',
              top: '80px',
            }}>

              <Grid container spacing={3}>
                <Grid item xs={12} id="company-info">
                  <Card>
                    <MDBox p={3}>
                      <div>
                        {templateReady && <form onSubmit={handleSubmit(handleSaveTemplate)} id={'templateForm'}>
                          <Row className={'mb-2'}>
                            <Col className={'col'} sm={6} xs={12}>

                              <div className="form-group">
                                <MDInput
                                  variant="outlined" type="text"
                                  {...register('templateName')}
                                  autoComplete="off" required
                                  className="form-control" id="templateName"
                                  InputLabelProps={{shrink: true}}
                                  label="Template Name"
                                  placeholder="Enter Template Name"/>
                              </div>
                            </Col>
                            <Col className={'col'} sm={6} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  variant="outlined" type="text"
                                  {...register('templateSubject')}
                                  autoComplete="off" required
                                  className="form-control" id="templateSubject"
                                  InputLabelProps={{shrink: true}}
                                  placeholder="Enter Template Email Subject"
                                  label="Email Subject"/>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col className={'col'} sm={12} xs={12}>

                              <CKEditor
                                editor={ClassicEditor}
                                config={{
                                  htmlSupport: {
                                    allow: [
                                      {
                                        name: /.*/,
                                        attributes: true,
                                        classes: true,
                                        styles: true
                                      }
                                    ]
                                  },
                                  toolbar: CONFIG.TOOLBAR,
                                  plugins: CONFIG.PLUGINS,
                                  extraPlugins: [
                                    uploadPlugin,
                                    previewPlugin
                                  ],
                                  placeholder: 'Enter Template Body',
                                }}
                                data={templateBody || ''}
                                onReady={editor => {
                                  handleReady(editor);
                                }}
                                onChange={(event, editor) => {
                                  handleChange(event, editor);
                                }}
                                onBlur={(event, editor) => {
                                  handleBlur(event, editor);
                                }}
                                onFocus={(event, editor) => {
                                }}
                              />
                              <Divider/>
                            </Col>
                          </Row>
                          <Row>
                            <Col className={'col'} sm={12} xs={12}>
                              <MDButton
                                type="submit"
                                variant="gradient"
                                size={'medium'}
                                disabled={saving}
                                color="info"
                                className={'pull-right'}>
                                {saving ? 'Saving' : 'Save'} Template</MDButton>
                            </Col>
                          </Row>

                        </form>
                        }
                      </div>
                    </MDBox>
                  </Card>

                  {/*<Grid container spacing={3}>*/}
                  {/*  <SampleTemplates*/}
                  {/*    onSelectTemplate={handleTemplateSelection}*/}
                  {/*  />*/}
                  {/*</Grid>*/}
                </Grid>

              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>

      {showPreview &&
        <Preview previewContent={preview}
                 previewTitle={'Template'}
                 showPreview={showPreview}
                 handleClose={() => {
                   setShowPreview(false);
                 }}/>
      }

      <Footer mt={5}/>

    </DashboardLayout>
  );
}